

import API from '@iso/lib/helpers/api';
import { clearToken, getToken } from '@iso/lib/helpers/utility';
import { createBrowserHistory } from 'history';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { createNotification } from '../../components/Notification';
import actions from './actions';

const history = createBrowserHistory();

export function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST', function*({ payload, history }) {
    const response = yield call(API.login, payload);
    console.log(response)
    if (response.status === 200) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: response.data.token,
        email: response.data.email,
        name: response.data.name,
        sand_capture_key: response.data.sand_capture_key,
        prod_capture_key: response.data.prod_capture_key,
        balance: response.data.balance,
        history
      });
      localStorage.setItem('id_token', response.data.token);
    } else if (response.status === 403) {
        yield put({ type: actions.UNVERIFIED_EMAIL, error: response.data, history, email: payload.email });
    } else if (response.status === 422 || response.status === 401) {
        yield put({ type: actions.LOGIN_ERROR, error: response.data, history, email: payload.email });
    } else {
      yield put({ type: actions.LOGIN_ERROR, error: response.data});
    }
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function*(payload) {
    yield createNotification('success', 'Welcome back', 'We are happy to see you again')
    yield localStorage.setItem('id_token', payload.token);
  });
}

export function* unverifiedEmail() {
  yield takeEvery(actions.UNVERIFIED_EMAIL, function*(payload) {
    console.log({payload})
    yield createNotification('error', 'Verify Account', payload.error.message)
    yield payload.history.push(`/confirm-email/${payload.email}`)
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function*(data) {
    console.log(data)
    yield createNotification('error', 'Not authorized.', data.error.message)
  });
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function*() {
    yield clearToken();
    history.push('/');
  });
}

export function* registerRequest() {
  yield takeEvery('REGISTER_REQUEST', function*({ payload }) {
    const response = yield call(API.register, payload);
    console.log(response)
      if (response.status === 201) {
        yield put({
          type: actions.REGISTER_SUCCESS,
          email: payload.email
        });
      } else {
        yield put({ type: actions.REGISTER_ERROR, payload: response });
      }
  });
}

export function* registerSuccess() {
  yield takeEvery(actions.REGISTER_SUCCESS, function*(payload) {
    yield createNotification('success', 'Verification code sent!', 'Check your e-mail to activate your account')
  });
}
export function* registerError() {
  yield takeEvery(actions.REGISTER_ERROR, function*(response) {
    const { error } = response;
    yield createNotification('error', 'Not authorized.', error.response.data.message)
  });
}
export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function*() {
    const token = getToken().get('idToken');
    if (token) {
      const response = yield call(API.userInfo, token);
      console.log(response.data)

      if(response && typeof response.data !== 'string') {
        const { balance, company, email, name, prod_capture_key, production_url, sand_capture_key, score_email, webhook } = response.data;
        console.log({balance, company, email, name, prod_capture_key, production_url,sand_capture_key, score_email,webhook})
        yield put({
          type: actions.LOGIN_SUCCESS,
          token,
          balance,
          company,
          production_url,
          score_email,
          webhook,
          name,
          email,
          sand_capture_key,
          prod_capture_key
        });
      } else {
        yield put({ type: actions.LOGOUT });
      }
    }
  });
}
export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),

    fork(loginRequest),
    // fork(loginSuccess),
    fork(loginError),
    
    fork(unverifiedEmail),
    
    fork(registerRequest),
    fork(registerSuccess),
    fork(registerError),

    fork(logout),
  ]);
}